import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.js';
import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import markerV2 from '../../../assets/images/marker_v2.png';
import markerShadow from '../../../assets/images/marker-shadow.png';

// Define custom marker icon
const defaultIcon = L.Icon.Default.mergeOptions({
  iconUrl: markerV2, // Your custom icon
  iconSize: [32, 32], // Size of your icon, adjust to maintain aspect ratio
  iconAnchor: [16, 32], // Anchor the bottom center of the icon (or adjust based on your needs)
  popupAnchor: [0, -32], // Adjust popup position
  shadowUrl: markerShadow, // Shadow URL
  shadowSize: [41, 41], // Size of the shadow image
  shadowAnchor: [16, 41], // Shadow alignment (adjust to your needs)
});

function LeafletControlGeocoder() {
  const map = useMap();
  const previousMarkerRef = useRef<L.Marker | null>(null);

  useEffect(() => {
    let geocoder = (L.Control as any).Geocoder.nominatim();

    const geocoderControl = (L.Control as any)
      .geocoder({
        query: '',
        placeholder: 'Search here...',
        defaultMarkGeocode: false,
        geocoder,
        position: 'topright',
      })
      .on('markgeocode', (e: any) => {
        const latlng = e.geocode.center;

        // Remove the previous marker if it exists
        if (previousMarkerRef.current) {
          map.removeLayer(previousMarkerRef.current);
        }

        // Add a new marker
        const newMarker = L.marker(latlng, { icon: defaultIcon }).addTo(map).bindPopup(e.geocode.name).openPopup();

        // Save the new marker reference
        previousMarkerRef.current = newMarker;

        // Adjust the map to fit the bounds
        map.fitBounds(e.geocode.bbox);
      })
      .addTo(map);
    // Add a tooltip to the search bar
    const geocoderElement = document.querySelector('.leaflet-control-geocoder');
    if (geocoderElement) {
      geocoderElement.setAttribute('title', 'Search');
    }
    return () => {
      map.removeControl(geocoderControl); // Clean up geocoder control
      if (previousMarkerRef.current) {
        map.removeLayer(previousMarkerRef.current); // Remove any leftover marker
      }
    };
  }, [map]);

  return null;
}

export default LeafletControlGeocoder;
